import MyModal from "src/components/layout/MyModal";
import LomaActionsLayout from "./layout/LomaActionsLayout";
import { LomaContext } from "src/context/LomaContext";
import { parse_yyyymmddhhmm, pvmStringLong, viikonpv } from "src/components/js/statics1";
import PropTypes from "prop-types";
import { useContext } from "react";

export default function LomaActionModal({ isOpen, setIsOpen }) {
  const { selectedCell } = useContext(LomaContext) || {};
  const pvm = selectedCell ? parse_yyyymmddhhmm(selectedCell.pvm) : null;

  if (selectedCell === undefined) return null;

  return (
    <MyModal
      buttonSize="small"
      title={
        selectedCell && (
          <div style={{ display: "flex", gap: 6 }}>
            <div>
              {selectedCell.personFirstName} {selectedCell.personLastName}
            </div>
            <div>{viikonpv(pvm) + " " + pvmStringLong(pvm)}</div>
          </div>
        )
      }
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}>
      <LomaActionsLayout />
    </MyModal>
  );
}

LomaActionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};
